// Header.js

import React from 'react';
import { FaInfoCircle } from 'react-icons/fa';
import logo from '../logo.png';
import logo_small from '../logo_small.png';

function Header({ goonId, setGoonId, handleClick, showPopup, handleMouseEnter, handleMouseLeave }) {
    return (
        <div className="header-section">
            <div className="logo">
                <img src={logo} alt="Logo" className="desktop" />
                <img src={logo_small} alt="Logo" className="tablet" />
            </div>
            <div className="header-text">
                <form>
                    Goon #: <input type="number" value={goonId} onChange={e => setGoonId(e.target.value)} />
                    <button type="button" onClick={handleClick} className="action-button search-button">Find a Goon</button>            

                    <div className="info-popup-container">
                        <span className="info-icon" 
                            onMouseEnter={handleMouseEnter}
                            onMouseLeave={handleMouseLeave}>
                                <FaInfoCircle />
                        </span>
                        {showPopup && (
                            <div className="info-popup">
                                {/* ... (rest of the popup content remains the same) ... */}
                            </div>
                        )}           
                    </div> 
                </form>
            </div>
            <div className="header-right">&nbsp;</div>
        </div>
    );
}

export default Header;
